// DeleteConfirmModal.jsx
import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/slices/toastSlice";


export default function DeleteModal({ open, onClose, onConfirm, action,isDeleting = false ,title}) {
  const [closing, setClosing] = useState(false);
  const confirmRef = useRef(null);
  const cancelRef = useRef(null);
  const dispatch=useDispatch()

  useEffect(() => {
    if (open) {
      setClosing(false);
      setTimeout(() => cancelRef.current?.focus(), 50);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    function onKey(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        handleClose();
      } else if (e.key === "Tab") {
        const focusable = [cancelRef.current, confirmRef.current].filter(Boolean);
        if (focusable.length < 2) return;
        if (e.shiftKey) {
          if (document.activeElement === focusable[0]) {
            e.preventDefault();
            focusable[1].focus();
          }
        } else {
          if (document.activeElement === focusable[1]) {
            e.preventDefault();
            focusable[0].focus();
          }
        }
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);



  function closeWithAnimation() {
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
      onClose?.();
    }, 260);
  }

  function handleClose() {
    if (isDeleting) return; 
    closeWithAnimation();
  }

  async function handleConfirm() {
   await action()
  }

  return (
    <AnimatePresence>
      {open && (
        <>

          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: closing ? 0 : 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18 }}
            className="fixed inset-0 z-50 bg-black/45 backdrop-blur-sm"
            onClick={handleClose}
            aria-hidden
          />


          <motion.div
            key="modal"
            initial={{ opacity: 0, y: 12, scale: 0.98 }}
            animate={{ opacity: closing ? 0 : 1, y: closing ? 8 : 0, scale: closing ? 0.98 : 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.98 }}
            transition={{ type: "spring", stiffness: 320, damping: 28 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-confirm-title"
          >
            <div className="relative w-full max-w-md">
              <div className="rounded-2xl lg:py-10  py-2 flex flex-col justify-between bg-white shadow-xl overflow-hidden">
                {/* header */}
                <div className="flex items-start gap-3 p-5">
                  <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.05, type: "spring", stiffness: 300, damping: 20 }}
                    className="flex-shrink-0"
                  >
                 
                  </motion.div>

                  <div className="flex-1">
                    <h3 id="delete-confirm-title" className="text-center text-gray-800  md:text-[18px] text-md leading-6">
                        {title}
                    </h3>
               
                  </div>

                </div>

  
                <div className="flex  flex-row items-center justify-center gap-3 p-4 border-t border-gray-100">
                  
                  <button
                    ref={cancelRef}
                    onClick={handleClose}
                    disabled={isDeleting}
                    className={`w-max   flex justify-center md:text-[18px]  hover:bg-gray-400 hover:text-white text-center px-4 py-1 rounded-lg  transition
                      ${isDeleting ? "opacity-50 cursor-not-allowed" : "hover:shadow-sm"}
                      bg-white border-[1px] border-gray-400 text-gray-400`}
                  >
                    انصراف
                  </button>

                  <motion.button
                    ref={confirmRef}
                    onClick={handleConfirm}
                    whileTap={{ scale: 0.97 }}
                    disabled={isDeleting}
                    className={`w-auto  hover:bg-red-500 md:text-[18px] hover:text-white  text-center  inline-flex items-center justify-center gap-2 px-4 py-1 rounded-lg  transition
                  
                      bg-white border-[1px] border-red-600 text-red-600`}
                    aria-label="حذف"
                  >
   
                    {/* {isDeleting ? (
                      <svg
                        className="w-4 h-4 animate-spin text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-.894.553L4 4H2a1 1 0 000 2h1v9a3 3 0 003 3h6a3 3 0 003-3V6h1a1 1 0 100-2h-2l-1.106-1.447A1 1 0 0014 2H6zm3 7a1 1 0 10-2 0v5a1 1 0 102 0V9z" clipRule="evenodd" />
                      </svg>
                    )} */}
                    <span>{isDeleting ? "در حال حذف..." : "حذف"}</span>
                  </motion.button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
